import axios from 'axios';

function readXsrfToken() {
    const match = document.cookie.match(/(?:^|; )XSRF-TOKEN=([^;]*)/);
    if (!match) {
        return null;
    }

    try {
        return decodeURIComponent(match[1]);
    } catch (error) {
        return null;
    }
}

/**
 * Client axios verso qcenter (cross-subdomain da qlive).
 * Imposta X-XSRF-TOKEN quando il cookie è leggibile (stesso host qweb).
 */
export function createQcenterApiClient(baseURL) {
    const client = axios.create({
        baseURL: (baseURL || '').replace(/\/+$/, ''),
        withCredentials: true,
        headers: {
            Accept: 'application/json',
            'X-Requested-With': 'XMLHttpRequest',
        },
    });

    client.interceptors.request.use((config) => {
        const token = readXsrfToken();
        if (token) {
            config.headers['X-XSRF-TOKEN'] = token;
        }
        return config;
    });

    return client;
}

export async function ensureQcenterCsrfCookie(apiClient) {
    if (!apiClient) {
        return;
    }

    try {
        await apiClient.get('/sanctum/csrf-cookie');
    } catch (error) {
        // silenzioso: su cross-subdomain il cookie resta sul dominio qcenter
    }
}
